<template>
  <session-content-container :title="title">
    <template v-if="game">
      <v-row no-gutters>
        <v-col
          v-for="player in game.playerList"
          :key="player.id"
          class="pa-2 d-flex flex-column"
          cols="12"
          md="6"
          lg="4"
          xl="3"
        >
          <player-card
            :value="player"
            class="flex-grow-1"
            score-key="sequential"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <bar-chart-card
            :game="game"
            :title="$t('animation.multitask.timeChartTitle')"
            indicator="timePlayed"
            sequential
            :step-size="10"
            :suggested-max="100"
          />
        </v-col>
        <v-col cols="6">
          <bar-chart-card
            :game="game"
            :title="$t('animation.multitask.mistakesChartTitle')"
            indicator="numberOfMistakes"
            sequential
            :step-size="1"
            :suggested-max="10"
          />
        </v-col>
      </v-row>
    </template>
  </session-content-container>
</template>

<script>
import _throttle from 'lodash/throttle'
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import SessionContentContainer from '../SessionContentContainer'
import PlayerCard from '../../components/multi-task/PlayerCard'
import BarChartCard from '../../components/multi-task/BarChartCard'

export default {
  name: 'MultiTaskSequentialContainer',
  components: {
    SessionContentContainer,
    PlayerCard,
    BarChartCard,
  },
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    gameId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    game: null,
  }),
  computed: {
    title () {
      if (this.loading) {
        return this.$t('general.loading')
      }
      return this.$t('animation.menu.games.multiTaskSequential')
    },
  },
  sockets: {
    trainingSessionPlayerLoggedIn ({ idSession }) {
      if (this.sessionId === idSession) {
        this.fetchData()
      }
    },
    multiTaskSessionPlayerReady ({ multiTaskSessionId }) {
      if (multiTaskSessionId === this.gameId) {
        this.fetchData()
      }
    },
    multiTaskSessionPlayerPlaying ({ multiTaskSessionId }) {
      if (multiTaskSessionId === this.gameId) {
        this.fetchData()
      }
    },
    multiTaskSessionPlayerFinished ({ multiTaskSessionId }) {
      if (multiTaskSessionId === this.gameId) {
        this.fetchData()
      }
    },
  },
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.fetchData()
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showErrorNotification: 'showErrorNotification',
    }),
    fetchData: _throttle(async function fetchData () {
      this.game = await Repositories.animation.multitask.get(this.gameId)
      // Show message only during the first load (not on data refresh)
      this.loading = false
    }, 200, { leading: true, trailing: true }),
    async sendPlayerAction (playerId, actionName) {
      try {
        await Repositories.animation.multitask.sendAction({
          gameId: this.gameId,
          playerId,
          actionName,
        })
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
        console.error(error)
      }
    },
  },
  provide () {
    return {
      sendPlayerAction: this.sendPlayerAction,
    }
  },
}
</script>
